export default function getIdFromKey(key: string): string {
  if (key?.length > 36) {
    const id = key?.substring(36)
    return id
  }
  return key
}
